<div *ngIf="IsHamburgerMenuOpen; else sectionView" class="hamburger-menu-container">
	<ng-container *ngFor="let item of ParentMenuItemsToShow">
		<div *ngIf="!item.ChildMenuItems?.length" [ngClass]="{'navbar-item crown-light-blue-background-hover': true, 'open-menu-item': IsHamburgerMenuOpen}">
			<crownx-navbar-link [MenuItem]="item"></crownx-navbar-link>
		</div>
		<ng-container *ngFor="let childMenuItem of item.ChildMenuItems"> 
			<div [ngClass]="{'navbar-item crown-light-blue-background-hover': true, 'open-menu-item': IsHamburgerMenuOpen}">
				<crownx-navbar-link [MenuItem]="childMenuItem" (MenuItemActionTriggered)="MenuItemActionTriggered.emit()"></crownx-navbar-link>
			</div>
		</ng-container>
	</ng-container>
</div>
<ng-template #sectionView>
	<ng-container *ngFor="let parentItem of ParentMenuItemsToShow">
		<div class="navbar-item">
			<div class="navbar-section-text">
				<crownx-navbar-link [MenuItem]="parentItem"></crownx-navbar-link>
			</div>
			<div *ngIf="parentItem.ChildMenuItems?.length" class="menu-items-container">
				<ng-container *ngFor="let childMenuItem of parentItem.ChildMenuItems">
					<div class="navbar-item crown-light-blue-background-hover">
						<crownx-navbar-link [MenuItem]="childMenuItem" (MenuItemActionTriggered)="MenuItemActionTriggered.emit()"></crownx-navbar-link>
					</div>
				</ng-container>
			</div>
		</div>
	</ng-container>
</ng-template>